import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';


const wStyles = theme => ({
    textLink:{
        //height:30,
        width:"90%",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:15,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
            cursor:"pointer"
        }  
    }
})

class DeleteArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
            boundary:null,
            hover:false
        }
        this.optionRef = React.createRef()
    }

    componentDidMount(){
        this.getBoundary()
    }

    componentDidUpdate(prevProps){
        if(prevProps.otherDragging !== this.props.otherDragging)
        {
            this.getBoundary()
        }
        if(prevProps.mousePos !== this.props.mousePos)
        {
            this.detectHover()
        }

    }

    componentWillUnmount(){

    }

    getBoundary=()=>{
        let rect = this.optionRef.current.getBoundingClientRect()
        let boundaryObj = {
            T:rect.top,
            B:rect.top+rect.height,
            L:rect.left,
            R:rect.left+rect.width
        }
        this.setState({
            boundary:boundaryObj
        })

        //this.props.getBoundary(boundaryObj)
    }

    detectHover=()=>{
        if(this.state.boundary)
        {
                        
                if(this.props.detectDirection === "x")
                {
                    if(this.props.mousePos.x > this.state.boundary.L && this.props.mousePos.x < this.state.boundary.R)
                    {
                        this.setState({
                            hover:true
                        })
                        let msg = true
                        this.props.getDeleteSequence(msg)   
                    }
                    else
                    {
                        this.setState({
                            hover:false
                        })
                        let msg = false
                        this.props.getDeleteSequence(msg)   
                    }
                }
                else if(this.props.detectDirection === "y")
                {
                    if(this.props.otherDragging)
                    {
                        if(this.props.mousePos.y > this.state.boundary.T && this.props.mousePos.y < this.state.boundary.B)
                        {
                            this.setState({
                                hover:true
                            })
                            let msg = true
                            this.props.getDeleteSequence(msg)   
                        }
                        else
                        {
                            this.setState({
                                hover:false
                            })
                            let msg = false
                            this.props.getDeleteSequence(msg)   
                        }
                    }
                    else
                    {
                        this.setState({
                            hover:false
                        })
                    }
                }
        }
    }



    
    render(){
        //const {classes} = this.props;
        let DeleteArea = {
            width:"90%",
            backgroundColor:"#bababa",
            display:"inline-block",
            borderRadius:"4px",
            marginBottom:"10px",
            color:"#000000"
        }

        let DeleteAreaHover = {
            width:"90%",
            backgroundColor:"#ff1100",
            display:"inline-block",
            borderRadius:"4px",
            marginBottom:"10px",
            color:"#ffffff"
        }

        let TagStyle = {
            fontFamily: "Microsoft JhengHei",
            fontSize: this.props.fontSize+"px",
            height: this.props.areaHeight? this.props.areaHeight+"px" : null,
            display: "inline-flex",
            alignItems: "center"
        }
       

        return(
            <div style={this.state.hover? DeleteAreaHover:DeleteArea} ref={this.optionRef}> 
                <div style={TagStyle}>
                    <DeleteIcon/>拖曳至此刪除
                </div>
            </div>
        )
    }
}

export default withStyles(wStyles)(DeleteArea)